<div [ngClass]="this.language == null || this.language === 'en' ? 'pre-login-en-css' : 'pre-login-other-css'">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-7 p-md-0 bg-alice">
        <app-main-sidebar></app-main-sidebar>

      </div>
      <div class="col-md-5">
        <div class="createPwdForm">
          <h2 class="mt-3 mb-3">
            <strong>{{ "SIGNUP.TITLE" | translate }}</strong>
          </h2>
          <form [formGroup]="createPwdForm" class="q-addDeviceModal" (ngSubmit)="onSignUp()">
            <div class="form-div">
              <div class="mt-2 mb-3 form-group">
                <label for="name" class="q-form-label mb-1">{{ "SIGNUP.NAME" | translate
                  }}<span class="text-danger">*</span></label>
                <input type="text" readonly autocomplete="off" class="q-form-control form-control"
                  placeholder="{{ 'SIGNUP.ENTERURNAME' | translate }}" [value]="getName" />
              </div>

              <div class="mt-2 mb-3 form-group">
                <label for="email" class="q-form-label mb-1">{{ "SIGNUP.EmailId" | translate
                  }}<span class="text-danger">*</span></label>
                <div>
                  <div class="align-items-baseline">
                    <input type="email" readonly autocomplete="off" class="q-form-control form-control pr-40"
                      placeholder="{{ 'SIGNUP.EmailEnter' | translate }}" [value]="getEmail" />
                    <div class="signup-showpwdIcon" *ngIf="emailVerified">
                      <img [src]="'IMAGES.VERIFIEDIMG'|translate" alt="" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-2 mb-3 form-group">
                <label for="password" class="mb-1 q-form-label">{{ "SIGNUP.PASSWORD" | translate
                  }}<span class="text-danger">*</span></label>
                <div class="dropdown info-dropdown cursor-pointer">
                  <img [src]="'IMAGES.INFORMATIONIMG'|translate" alt="" class="ms-2" />
                  <div class="dropdown-content">
                    <div class="d-flex flex-column">
                      <div class="fw-bold">
                        {{ "LOGIN.PASSWORDCRITERIA" | translate }}
                      </div>
                      <div>1. {{ "LOGIN.PASSWORDCONTAINS" | translate }}</div>
                      <div>
                        2. {{ "LOGIN.PASSWORDSPECIALCHARACTER" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex">
                  <input #testInput [type]="password" autocomplete="off" (keyup)="passwordVerify()"
                    formControlName="password" [ngClass]="{
                        'is-invalid': isSubmitted && f['password'].errors
                      }" class="q-form-control form-control pr-40"
                    placeholder="{{ 'SIGNUP.ENTERYOURPASSWORD' | translate }}" />

                  <div class="signup-showpwdIcon" (click)="onClick('pwd')">
                    <img [src]="'IMAGES.HIDEPWD'|translate" alt="" *ngIf="!newPassword" />
                    <img [src]="'IMAGES.SHOWPWD'|translate" alt="" *ngIf="newPassword" />
                  </div>
                </div>
                <div class="mw-340">
                  <p class="errMessage" *ngIf="createPwdForm.controls['password'].errors">
                    {{ "LOGIN.PASSWORDSPECIALCHARACTER" | translate }}<br />
                  </p>
                </div>
              </div>
              <div class="mt-2 mb-3 form-group">
                <label for="confirmPassword" class="mb-1 q-form-label">{{ "SIGNUP.CONFIRMPASSWORD" | translate
                  }}<span class="text-danger">*</span></label>
                <div class="dropdown info-dropdown cursor-pointer">
                  <img [src]="'IMAGES.INFORMATIONIMG'|translate" alt="" class="ms-2" />
                  <div class="dropdown-content">
                    <div class="d-flex flex-column">
                      <div class="fw-bold">
                        {{ "LOGIN.PASSWORDCRITERIA" | translate }}
                      </div>
                      <div>1. {{ "LOGIN.PASSWORDCONTAINS" | translate }}</div>
                      <div>
                        2. {{ "LOGIN.PASSWORDSPECIALCHARACTER" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex">
                  <input [type]="passwords" autocomplete="off" (keyup)="onFocusOut()" formControlName="confirmPassword"
                    [ngClass]="{
                        'is-invalid': isSubmitted && f['confirmPassword'].errors
                      }" class="q-form-control form-control pr-40"
                    placeholder="{{ 'SIGNUP.ENTERYOURPASSWORD' | translate }}" />
                  <div class="signup-showpwdIcon" (click)="onClick('confPwd')">
                    <img [src]="'IMAGES.HIDEPWD'|translate" alt="" *ngIf="!confPassword" class="cursor-pointer" />

                    <img [src]="'IMAGES.SHOWPWD'|translate" alt="" *ngIf="confPassword" class="cursor-pointer" />
                  </div>
                </div>
                <ng-container *ngIf="pwdNotMatch">
                  <p class="errMessage">
                    {{ "SIGNUP.CONFIRMPASSWORDDOESNOTMATCH" | translate }}
                  </p>
                </ng-container>

                <ng-container *ngIf="erroMessage">
                  <p class="errMessage">{{ erroMessage }}</p>
                </ng-container>

                <ng-container *ngIf="verifyEmailErrorMessage">
                  <p class="errMessage">
                    {{ verifyEmailErrorMessage }}
                  </p>
                </ng-container>
              </div>

              <div class="d-flex form-group mt-3">
                <label class="terms-checkbox">
                  <input type="checkbox" class="form-control q-form-control" formControlName="acceptTerms" [ngClass]="{
                        'is-invalid': isSubmitted && f['acceptTerms'].errors
                      }" />
                  <span class="checkmark"></span>
                </label>
                <div class="agree-txt" data-toggle="tooltip" i18n-title
                  title='{{ "SIGNUP.BySignIning" | translate }}{{ "SIGNUP.LicenceAgreement" | translate }}{{ "SIGNUP.AND" | translate }}{{ "SIGNUP.PrivacyPolicy" | translate }}'>
                  {{ "SIGNUP.BySignIning" | translate }} <br />
                  <span>
                    <a class="org-clr" href="https://www.quickheal.co.in/eula"
                      target="_blank" rel="noopener">
                      {{ "SIGNUP.LicenceAgreement" | translate }}
                    </a>
                    <span class="text-black mx-1">{{
                      "SIGNUP.AND" | translate
                      }}</span>
                    <a class="org-clr" href="https://www.quickheal.co.in/privacy-policy" target="_blank" rel="noopener">
                      {{ "SIGNUP.PrivacyPolicy" | translate }}</a>
                  </span>
                </div>
              </div>

              <div class="d-flex flex-column flex-lg-row  mt-3" *ngIf='fullWidthDiv'>
                <div class="me-3 mb-3 mb-lg-0 w-lg-50 w-100">
                  <button type="submit" [disabled]="
                        createPwdForm.invalid ||
                        pwdNotMatch ||
                        verifyEmailErrorMessage
                      " [ngClass]="
                        createPwdForm.invalid ||
                        pwdNotMatch ||
                        verifyEmailErrorMessage
                          ? 'q-invalid-button '
                          : 'submit-btn bg-orgclr '
                      ">
                    {{ "LOGIN.SIGNUP" | translate }}
                  </button>
                </div>
                <div class="w-lg-50 w-100">
                  <button type="button" class="cancel-btn bg-cancelbtn w-100" routerLink="/">
                    {{ "LOGIN.CANCEL" | translate }}
                  </button>
                </div>
              </div>
              <div class="d-flex flex-column mt-3" *ngIf='!fullWidthDiv'>
                <div class="mb-3 w-100">
                  <button type="submit" [disabled]="
                        createPwdForm.invalid ||
                        pwdNotMatch ||
                        verifyEmailErrorMessage
                      " [ngClass]="
                        createPwdForm.invalid ||
                        pwdNotMatch ||
                        verifyEmailErrorMessage
                          ? 'q-invalid-button '
                          : 'submit-btn bg-orgclr '
                      ">
                    {{ "SIGNUP.CreateAccount" | translate }}
                  </button>
                </div>
                <div class="w-100">
                  <button type="button" class="cancel-btn bg-cancelbtn" routerLink="/">
                    {{ "LOGIN.CANCEL" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <footer>
      <div class="login-footer">
        <div class="row p-0" style="position: relative">
          <div class="col-12 col-md-7 bg-alice">
            <div class="row">
              <div class="col-12 col-sm-8 col-lg-12 col-xl-9">
                <div class="mb-0 footer-text">
                  © 2022 {{ "LOGIN.QUICKHEALTECHNOLOGIES" | translate }}
                  {{ "SIGNUP.ALLRIGHTSRESERVED" | translate }}.
                  <a href="https://www.quickheal.co.in/privacy-policy" rel="noopener" target="_blank">{{
                    "SIGNUP.PrivacyPolicy" | translate }}</a>
                  |
                  <a href="https://www.quickheal.co.in/eula" target="_blank"
                    rel="noopener">{{
                    "SIGNUP.LicenceAgreement" | translate }}</a>
                </div>
              </div>
              <div class="col-12 my-2 my-sm-0 col-sm-4 col-lg-12 col-xl-3 text-end">
                <div class="socialIconsHW">
                  <a href="https://twitter.com/quickheal" target="_blank" rel="noopener">
                    <div class="me-2 twitter"></div>
                  </a>
                  <a href="https://www.facebook.com/quickhealav" target="_blank" rel="noopener">
                    <div class="me-2 facebook"></div>
                  </a>

                  <a href="https://blogs.quickheal.com" target="_blank" rel="noopener">
                    <div class="me-2 blogs"></div>
                  </a>
                  <a href="https://www.youtube.com/user/quickheal" target="_blank" rel="noopener">
                    <div class="me-2 youtube"></div>
                  </a>
                  <a href="https://techsupport.quickheal.com/index.php?/selfhelp/categories" target="_blank"
                    rel="noopener">
                    <div class="me-2 quickheal"></div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-0 col-md-5"></div>
        </div>
      </div>
    </footer>
  </div>

  <!-- Link Expired Popup -->

  <div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto" id="linkExpired"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
    aria-hidden="true">
    <div class="modal-dialog relative w-auto pointer-events-none text-center modal-dialog-centered">
      <div
        class="modal-content border-none shadow-lg relative pointer-events-auto rounded-25 p-3 bg-white outline-none">
        <ng-container *ngIf="getLimitandLink === 'LIMIT_EXCEEDS'">
          <div class="mt-3">
            <img [src]="'SIGNUP.LIMITEXCEEDIMG'|translate" alt="" class="mx-auto limitexceedImg" />
          </div>
          <h5 class="mt-3 fw-bold">
            {{ "SIGNUP.UsrLimitExceed" | translate }}
          </h5>

          <div>
            <button class="submit-btn bg-orgclr w-auto" data-bs-dismiss="modal">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="getLimitandLink === 'URL_EXPIRED'">
          <div class="mt-3">
            <img [src]="'SIGNUP.LINKEXPIREDIMG'|translate" alt="" class="mx-auto limitexceedImg" />
          </div>
          <h5 class="mt-3 fw-bold">
            {{ "SIGNUP.LinkExpired" | translate }}
          </h5>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="modal" id="signupSuccess" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div
        class="modal-content rounded-25 border-none shadow-lg relative d-flex flex-column w-100 pointer-events-auto bg-white outline-none">
        <div class="modal-body relative pt-3">
          <div class="text-center mt-3">
            <div>
              <img [src]="'SIGNUP.SUCCESSIMG'|translate" alt="" class="mx-auto" />
            </div>
            <h5 class="fw-bold q-form-heading mt-3">
              {{ "SUCESSMESSAGE.Congratulations" | translate }}
            </h5>
            <p class="my-3">
              {{ "SUCESSMESSAGE.SUccessFullySignup" | translate }}
            </p>
            <button class="submit-btn bg-orgclr w-auto mb-3" type="button" (click)="goToLogin()">
              {{ "SIGNUP.SIGNIN" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>